
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import * as audioActions from '../../../../Core/Game/AudioContainer/audio.actions'

class ColonyName extends React.Component {
  constructor(props) {
    super(props)
    this.nameInput = React.createRef()
  }

  next() {
    const { next, addHowlSound } = this.props
    addHowlSound('button_click_icon')
    if (this.nameInput.current.value) {
      next(this.nameInput.current.value)
    }
  }

  render() {
    const { name, intl, error } = this.props

    return (
      <div className="container background background--challenge">
        <div className="content">
          <div className="mars--create__name">
            <div className="mars--title">
              <FormattedMessage id={'colony.create'} />
            </div>
            <div className="mars--cologne__name">
              <div className="text">
                <FormattedMessage id={'colony.selectName'} />
              </div>
              <input
                type="text"
                className="mars--input__name"
                maxLength="20"
                ref={this.nameInput}
                defaultValue={name}
                placeholder={intl.formatMessage({ id: 'colony.selectNamePlaceholder' })}
              />
              {error ? (
                <div className="text error">
                  <FormattedMessage id={'colony.error'} />
                </div>
              ) : null}
              <div onClick={() => this.next()} className="btn--orange">
                <span className="icon-rocket"></span>
                <span>
                  <FormattedMessage id={'colony.next'} />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  }
}
ColonyName.propTypes = {
  name: PropTypes.string,
  error: PropTypes.any,
  next: PropTypes.func,
  addHowlSound: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(injectIntl(ColonyName))
